import { useState } from "react";
import React, { ReactNode } from "react";
import parse from "html-react-parser";
import Icon from "@/components/icons";
import { SectionProps } from "./types";
import Link from "next/link";
import useTranslations from "@/i18n/useTranslations";

interface DefaultProps {
  expertise?: string;
  accomplishments?: string;
  education?: string;
  website?: string;
  linkedin?: string;
}

const QualificationsSummary = ({
  expertise,
  accomplishments,
  education,
  website,
  linkedin,
}: DefaultProps) => {
  const t = useTranslations("Common");
  const tExpand = useTranslations("ExpandableBlock");
  const [open, setOpen] = useState<boolean>(false);

  const Section = ({ classes, type, label, content }: SectionProps) => {
    return (
      <div className={classes + " mb-4"}>
        <div className="flex items-center whitespace-nowrap ml-2 mt-2">
          <Icon
            type={type ?? ""}
            svgProps={{ width: "22", height: "22" }}
            pathProps={{ fill: "white" }}
          />
          <div className="ml-2 font-bold block">{label}</div>
        </div>
        {content && parse(content)}
      </div>
    );
  };

  return (
    <div className="overflow-auto p-2 rounded-xl border border-solid text-white bg-secondary-500 no-underline h-fit">
      {expertise && (
        <Section
          key="expertise"
          type="circle-check"
          label={t("expertise")}
          content={expertise}
        />
      )}
      {(education !== "" || accomplishments !== "") && (
        <>
          <span
            onClick={() => setOpen(true)}
            id="toggle-btn"
            className={
              open
                ? "hidden"
                : "block float-left m-2 underline text-white focus:outline-none md:hidden"
            }
          >
            {tExpand("showMore")}
          </span>
          {education && (
            <Section
              classes={open ? "" : "hidden md:block"}
              key="education"
              type="school"
              label={t("education")}
              content={education}
            />
          )}
          {accomplishments && (
            <Section
              classes={open ? "" : "hidden md:block"}
              key="accomplishments"
              type="award"
              label={t("accomplishments")}
              content={accomplishments}
            />
          )}
        </>
      )}
      <hr
        className={
          open
            ? "h-px mx-auto my-4 w-5/6 bg-secondary-300 border-0 rounded-sm"
            : "hidden md:block"
        }
      />
      <div
        className={
          open ? "flex justify-center" : "hidden md:flex justify-center p-1"
        }
      >
        {website && (
          <Link
            aria-label={t("contributorWebsite")}
            href={website}
            className="p-1"
          >
            <Icon type="launch"></Icon>
          </Link>
        )}
        {linkedin && (
          <Link
            href={linkedin}
            aria-label={t("linkedinProfile")}
            className="p-1"
          >
            <Icon type="linkedin"></Icon>
          </Link>
        )}
      </div>
    </div>
  );
};

export default QualificationsSummary;
